import { useNavigate } from 'react-router-dom'
import { Box, Divider, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { AppBar, AppLogo } from '@/common/components'
import { getProductDetails, Paths } from '@/common/utils'

const classes = {
    appBar: {
        backgroundColor: 'white',
        color: 'white',
        displayPrint: 'none',
    },
    appLogo: {
        height: 32,
        px: 1,
        py: 1,
        cursor: 'pointer',
        boxSizing: 'content-box',
    },
    toolbarItems: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'flex-end',
    },
    menuDivider: {
        backgroundColor: 'divider',
        margin: '10px 16px',
    },
}

const PublicAppBar = () => {
    const navigate = useNavigate()
    const productDetails = getProductDetails()

    return (
        <AppBar
            position="sticky"
            sx={classes.appBar}
        >
            <AppLogo
                logoUrl={productDetails.logo}
                sx={classes.appLogo}
                onClick={() => navigate(Paths.DASHBOARD_PATHNAME)}
            />

            <Divider
                orientation="vertical"
                sx={classes.menuDivider}
                flexItem
            />
        </AppBar>
    )
}

export default PublicAppBar
